export const API_BASE_URL = 'https://screeneagle-kakao-api-prod.hnstudio-c.workers.dev'

export const PLAN_CONFIG = {
  starter: {
    name: 'Starter',
    nameKo: '스타터',
    amount: 5000,
    points: 5000,
    duration_days: 7,
  },
  basic: {
    name: 'Basic',
    nameKo: '베이직',
    amount: 10000,
    points: 10000,
    duration_days: 30,
  },
  pro: {
    name: 'Pro',
    nameKo: '프로',
    amount: 50000,
    points: 100000,
    duration_days: 30,
  },
  expert: {
    name: 'Expert',
    nameKo: '엑스퍼트',
    amount: 100000,
    points: 200000,
    duration_days: 365,
  },
} as const

export const POINT_COSTS = {
  alimtalk: 30,
  alimtalk_with_link: 30,
  sms_fallback: 20,
  local_only: 0,
} as const

export const PG_PROVIDERS = {
  kakaopay: {
    name: 'KakaoPay',
    nameKo: '카카오페이',
    icon: '💛',
  },
  naverpay: {
    name: 'NaverPay',
    nameKo: '네이버페이',
    icon: '💚',
  },
} as const

export const NOTIFICATION_TYPES = {
  alimtalk: {
    name: 'Alimtalk',
    nameKo: '알림톡',
    cost: 30,
  },
  alimtalk_with_link: {
    name: 'Alimtalk with Link',
    nameKo: '알림톡 + 링크',
    cost: 30,
  },
  brandmsg: {
    name: 'Brand Message',
    nameKo: '브랜드메시지',
    cost: 100,
  },
} as const

export const TOKEN_KEYS = {
  ACCESS_TOKEN: 'screeneagle_access_token',
  REFRESH_TOKEN: 'screeneagle_refresh_token',
  USER: 'screeneagle_user',
} as const
